// extracted by mini-css-extract-plugin
export default {"header":"SwYoA","input":"sqfoQ no-spinner"};